import { AxiosRequestConfig } from 'axios'

export interface UserTestParams {
  startDate: string
  endDate: string
  onlyActive?: boolean
}

export interface TestCompletionData {
  completed: number
  partialProgress: number
  neverOpened: number
  totalUsers: number
}

export interface UserTestResponse {
  data: TestCompletionData
}

const getUserTestStats = (params: UserTestParams): AxiosRequestConfig => ({
  url: '/dashboard/user-test-stats',
  method: 'GET',
  params,
})

export { getUserTestStats }
